import styled from "styled-components"

export default styled.h1`
  font-size: 26px;
  margin: 0;
  font-weight: 700;
  color: #000;
  text-align: center;
`
